/* ============================================================
   Modulo Photo Marquee — seamless infinite scroll.

   Mirrors the logo-cloud engine, generalized to N rows:
   - For each track, measure one "cycle" = width of N original
     items + one gap each.
   - Clone enough copies that the track ≥ viewport + 1 cycle, so
     off-screen content is always queued on both sides.
   - Set --modulo-pm-cycle-width so CSS animates by exact pixels,
     landing on a clean cycle boundary every loop — no visible snap,
     no CLS (animation only attaches once ready).
   ============================================================ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  function getGap(el) {
    var style = getComputedStyle(el);
    var raw = style.columnGap || style.gap || '0';
    var n = parseFloat(raw);
    return isNaN(n) ? 0 : n;
  }

  function measureCycle(originals, gap) {
    var w = 0;
    for (var i = 0; i < originals.length; i++) {
      w += originals[i].getBoundingClientRect().width;
    }
    // One gap per item so the cycle includes its trailing gap,
    // keeping the loop boundary aligned between repeats.
    return w + gap * originals.length;
  }

  function cloneSet(track, originals) {
    for (var i = 0; i < originals.length; i++) {
      var clone = originals[i].cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('role');
      track.appendChild(clone);
    }
  }

  function initTrack(track, viewportWidth) {
    if (!track || track.dataset.moduloPmReady === '1') return;

    var originals = Array.prototype.slice.call(track.children);
    if (originals.length === 0) return;

    var gap = getGap(track);
    var cycleWidth = measureCycle(originals, gap);
    if (cycleWidth <= 0) return; // images not laid out yet — bail, resize will retry

    var required = viewportWidth + cycleWidth;
    var copiesNeeded = Math.max(2, Math.ceil(required / cycleWidth));
    for (var c = 0; c < copiesNeeded; c++) cloneSet(track, originals);

    track.style.setProperty('--modulo-pm-cycle-width', cycleWidth + 'px');
    track.dataset.moduloPmReady = '1';
  }

  function initMarquee(el) {
    var viewportWidth = el.offsetWidth || document.documentElement.clientWidth;
    var tracks = el.querySelectorAll('.modulo-pm__track');
    for (var i = 0; i < tracks.length; i++) initTrack(tracks[i], viewportWidth);
  }

  function bootstrap() {
    if (window.moduloLazyInit) {
      window.moduloLazyInit('[data-modulo-pm]', initMarquee);
    } else {
      var els = document.querySelectorAll('[data-modulo-pm]');
      for (var i = 0; i < els.length; i++) initMarquee(els[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  // Re-measure on resize so wider screens stay filled. Only ADD clones.
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var els = document.querySelectorAll('[data-modulo-pm]');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var tracks = el.querySelectorAll('.modulo-pm__track');
        for (var t = 0; t < tracks.length; t++) {
          var track = tracks[t];
          if (track.dataset.moduloPmReady !== '1') {
            initTrack(track, el.offsetWidth || document.documentElement.clientWidth);
            continue;
          }
          var needed = (el.offsetWidth || 0) * 2;
          var safety = 0;
          while (track.scrollWidth < needed && safety < 4) {
            var snapshot = Array.prototype.slice.call(track.children);
            for (var j = 0; j < snapshot.length; j++) {
              var clone = snapshot[j].cloneNode(true);
              clone.setAttribute('aria-hidden', 'true');
              clone.removeAttribute('role');
              track.appendChild(clone);
            }
            safety++;
          }
        }
      }
    }, 200);
  });
})();
